(function () {
  // ---- Productgrid: filter + sorteer (alleen waar een grid bestaat) ----
  document.querySelectorAll('[data-cov-grid]').forEach(function (grid) {
    var root = grid.closest('[data-cov-root]') || document;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-cov-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-cov-filter]'));
    var sortSel = root.querySelector('[data-cov-sort]');
    var countEl = root.querySelector('[data-cov-count]');
    var current = 'alle';
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var use = c.getAttribute('data-use') || '';
        var sale = c.getAttribute('data-sale') === '1';
        var ok = current === 'alle' ? true : (current === 'aanbieding' ? sale : use.indexOf(current) >= 0);
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown + ' producten';
      var vis = cards.filter(function (c) { return c.style.display !== 'none'; });
      var s = sortSel ? sortSel.value : 'aanbevolen';
      vis.sort(function (a, b) {
        if (s === 'laag') return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
        if (s === 'hoog') return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
        return parseFloat(a.getAttribute('data-ord')) - parseFloat(b.getAttribute('data-ord'));
      });
      vis.forEach(function (c, idx) { c.style.order = idx; });
    }
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        current = b.getAttribute('data-cov-filter');
        chips.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        apply();
      });
    });
    if (sortSel) sortSel.addEventListener('change', apply);
    apply();
  });

  // ---- Add-to-cart (document-breed, werkt in grid, cross-sell, dispensers, quiz-result) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cov-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-variant-id');
    var url = btn.getAttribute('data-url');
    if (btn.getAttribute('data-multi') === '1' && url) { window.location.href = url; return; }
    if (!id) { if (url) window.location.href = url; return; }
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else window.location.href = '/cart';
    }).catch(function () { if (url) window.location.href = url; }).finally(function () { btn.dataset.busy = ''; });
  });

  // ---- FAQ accordion (document-breed) ----
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-cov-faq-head]');
    if (!head) return;
    var item = head.closest('[data-cov-faq]');
    if (item) item.classList.toggle('is-open');
  });

  // ---- Bekend-van marquee: kloon de groep tot de rij altijd ruim de viewport vult ----
  function initMarquee() {
    var track = document.querySelector('.cov2-bvk__track');
    if (!track || track.dataset.mqReady) return;
    var groups = track.querySelectorAll('.cov2-bvk__group');
    if (!groups.length) return;
    var groupW = groups[0].getBoundingClientRect().width;
    if (!groupW) return; // wacht tot logo's geladen zijn
    var perHalf = Math.max(2, Math.ceil((window.innerWidth * 1.2) / groupW));
    var totalNeeded = perHalf * 2; // even aantal identieke groepen -> -50% blijft naadloos
    for (var i = groups.length; i < totalNeeded; i++) {
      var clone = groups[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
    track.dataset.mqReady = '1';
  }
  initMarquee();
  window.addEventListener('load', initMarquee);

  // ---- Verwarmertest (quiz) ----
  var quizEl = document.querySelector('[data-cov-quiz]');
  if (quizEl) {
    var dataNode = quizEl.querySelector('[data-cov-quiz-json]');
    var cfg = null;
    try { cfg = JSON.parse(dataNode.textContent); } catch (err) { cfg = null; }
    if (cfg) {
      var stage = quizEl.querySelector('[data-cov-quiz-stage]');
      var answers = [];
      function arrow() { return '<span class="cov-arrow">&rarr;</span>'; }
      function renderQuestion() {
        var step = Math.min(answers.length, cfg.questions.length - 1);
        var q = cfg.questions[step];
        var pct = Math.round((answers.length / cfg.questions.length) * 100);
        var html = '' +
          '<div class="cov-quiz-meta">Vraag ' + (answers.length + 1) + ' van ' + cfg.questions.length + '</div>' +
          '<div class="cov-quiz-prog"><span style="width:' + pct + '%"></span></div>' +
          '<h3 class="cov-quiz-q">' + q.q + '</h3>' +
          '<div class="cov-quiz-opts">';
        q.opts.forEach(function (o, j) {
          html += '<button type="button" class="cov-quiz-opt" data-cov-quiz-opt="' + j + '">' + o.label + '<span class="cov-quiz-dot"></span></button>';
        });
        html += '</div>';
        stage.innerHTML = html;
      }
      function renderResult() {
        var scores = {};
        cfg.order.forEach(function (k) { scores[k] = 0; });
        answers.forEach(function (oi, qi) {
          var sm = cfg.questions[qi].opts[oi].s || {};
          Object.keys(sm).forEach(function (k) { if (scores[k] === undefined) scores[k] = 0; scores[k] += sm[k]; });
        });
        var best = cfg.order[0], bestV = -1;
        cfg.order.forEach(function (k) { if (scores[k] > bestV) { bestV = scores[k]; best = k; } });
        var fam = cfg.families[best];
        var html = '' +
          '<div class="cov-quiz-rlabel">Jouw match</div>' +
          '<h3 class="cov-quiz-rname">' + fam.name + '</h3>' +
          '<p class="cov-quiz-rwhy">' + fam.why + '</p>' +
          '<div class="cov-quiz-variants">';
        fam.handles.forEach(function (h) {
          var p = cfg.products[h];
          if (!p) return;
          html += '<a class="cov-qvar" href="' + p.href + '">' +
            '<span class="cov-qvar-img" style="background-image:url(\'' + p.img + '\')"></span>' +
            '<span class="cov-qvar-body"><span class="cov-qvar-label">' + p.label + '</span>' +
            '<span class="cov-qvar-row"><span class="cov-price">' + p.price + '</span>' +
            '<span class="cov-qvar-cta">Bekijk ' + arrow() + '</span></span></span></a>';
        });
        html += '</div>' +
          '<button type="button" class="cov-quiz-restart" data-cov-quiz-restart>Opnieuw doen</button>';
        stage.innerHTML = html;
      }
      function update() {
        if (answers.length >= cfg.questions.length) renderResult();
        else renderQuestion();
      }
      stage.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-cov-quiz-opt]');
        if (opt) { answers.push(parseInt(opt.getAttribute('data-cov-quiz-opt'), 10)); update(); return; }
        if (e.target.closest('[data-cov-quiz-restart]')) { answers = []; update(); }
      });
      update();
    }
  }
})();
